import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'

//i18n
import { withTranslation } from 'react-i18next'

class ManagementContent extends Component {
	constructor(props) {
		super(props)
		this.refDiv = React.createRef()
	}

	render() {
		const { t } = this.props
		return (
			<React.Fragment>
				<li>
					<Link to="/#" className="has-arrow">
						<i className="bx bx-store" />
						<span>{t('management', { ns: 'naming' })}</span>
					</Link>
					<ul className="sub-menu" aria-expanded="false">
						<li>
							<Link to="/offer-list">{t('offers', { ns: 'naming' })}</Link>
						</li>
						<li>
							<Link to="/orders">{t('orders', { ns: 'naming' })}</Link>
						</li>
						<li>
							<Link to="/productions">{t('productions', { ns: 'naming' })}</Link>
						</li>
						<li>
							<Link to="/billing">{t('billing', { ns: 'naming' })}</Link>
						</li>
						<li>
							<Link to="/reports">{t('reports', { ns: 'naming' })}</Link>
						</li>
					</ul>
				</li>
			</React.Fragment>
		)
	}
}

ManagementContent.propTypes = {
	location: PropTypes.object,
	t: PropTypes.any,
	type: PropTypes.string,
	initMenu: PropTypes.func,
}

export default withRouter(withTranslation()(ManagementContent))
